export default () => ({
  items: [],
  current: undefined,
  nameToCreate: '',
  deletionPending: [],
  creationPending: false,
  updatePending: [],
  collectionName: null,
  color: 'grey'
})
